export enum ColumnasPefEnum {
    EDO = 0,
    UR = 1,
    UT = 2,
    K = 3,
    NO_SOLICITUD = 4,
    REGISTRO = 5,
    NOMBRE_OBRA = 6,
    PRESUPUESTO_ETIQUITADO_EN_DOF = 7,
    PEF = 8,
    META_PEF = 9,
    MODIFICADO_SIA = 10,
    CONTRATADO_EN_SISTEMA = 11,
    CALENDARIO = 12,
    EJERCIDO_EN_TRAMITE = 13,
    EJERCIDO_SIA = 14,
    EJERCIDO_SIAFF = 15,
    TOTAL_EJERCIDO = 16,
    CALENDARIO_VS_TOTAL_EJERCIDO = 17,
    OBSERVACIONES = 18
}
